import * as React from 'react';
export const listViewSvg = React.forwardRef(function listViewSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M0 1.5A1.5 1.5 0 0 1 1.5 0h9A1.5 1.5 0 0 1 12 1.5v2.25a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 0 3.75V1.5Zm1.5-.2h9c.11 0 .2.09.2.2v2.25a.2.2 0 0 1-.2.2h-9a.2.2 0 0 1-.2-.2V1.5c0-.11.09-.2.2-.2ZM0 8.25a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5v2.25a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 0 10.5V8.25Zm1.5-.2h9c.11 0 .2.09.2.2v2.25a.2.2 0 0 1-.2.2h-9a.2.2 0 0 1-.2-.2V8.25c0-.11.09-.2.2-.2Z',
      clipRule: 'evenodd',
    }),
  );
});
listViewSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var listView = {
  category: 'icon',
  colorable: true,
  name: 'listView',
  svg: listViewSvg,
};
